import { z } from "zod";
import { schemes } from "@zeal/common";
import { createInvoiceResponseSchema } from "../createInvoice/createInvoice.schema";

/**
 * Request schema for GET /api/invoices
 * Response schema for GET /api/invoices
 */

export const getInvoicesRequestSchema = z.object({
  companyID: schemes.companyID(),
  search: z.string().optional().default(""),
});

export type TGetInvoicesRequest = z.infer<typeof getInvoicesRequestSchema>;

export const getInvoicesResponseSchema = z.object({
  invoices: z.array(
    createInvoiceResponseSchema.extend({
      customer_name: z.string(),
    })
  ),
});

export type TGetInvoicesResponse = z.infer<typeof getInvoicesResponseSchema>;
